import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Section, SectionHeader, Bleed } from 'components/ds';
import { IcCalendar, IcPlane } from 'components/common/icons/EmojiIcons';
import styles from './CreateMeetingSection.module.css';

const STORAGE_KEY = 'meeting_create_data';

/**
 * 모임 만들기 — 당일/여행 두 장 + 초대코드 줄.
 *
 * 주요기능 탭에 있던 것을 홈에서도 쓰게 되어 이리로 옮겼습니다.
 * 두 벌로 두면 한쪽만 고쳐져 갈라지므로 한 곳에만 둡니다.
 */
export const CreateMeetingSection = ({ spacing }: { spacing?: 'tight' }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const createMeeting = (type: 'DAY' | 'TRAVEL') => {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ meetingType: type }));
        navigate('/meeting/create/step2');
    };

    return (
        <Section spacing={spacing}>
            <SectionHeader title={t('functions.sectionCreate')} />
            <div className={styles.createGrid}>
                <button type="button" className={styles.create} onClick={() => createMeeting('DAY')}>
                    <span className={styles.createIcon}><IcCalendar size={22} /></span>
                    <span className={styles.createTitle}>{t('functions.dayMeeting')}</span>
                    <span className={styles.createSub}>{t('functions.dayMeetingDesc')}</span>
                </button>
                <button type="button" className={styles.create} onClick={() => createMeeting('TRAVEL')}>
                    <span className={styles.createIcon}><IcPlane size={22} /></span>
                    <span className={styles.createTitle}>{t('functions.travelMeeting')}</span>
                    <span className={styles.createSub}>{t('functions.travelMeetingDesc')}</span>
                </button>
            </div>
            <Bleed>
                <button type="button" className={styles.invite} onClick={() => navigate('/join-code')}>
                    {t('functions.joinByCode')}
                    <span className={styles.inviteCta}>{t('homeComp.enterInviteCode')}</span>
                </button>
            </Bleed>
        </Section>
    );
};
